// extracted by mini-css-extract-plugin
export var cardTitle = "_jv-1";
export var commentBubble = "_jv-e";
export var commentForm = "_jv-a";
export var commentInput = "_jv-b";
export var commentLabel = "_jv-d";
export var commentPrompt = "_jv-9";
export var csatCard = "_jv-0";
export var feedbackSection = "_jv-7";
export var starDisabled = "_jv-6";
export var starEmpty = "_jv-5";
export var starFilled = "_jv-4";
export var starWrapper = "_jv-3";
export var starsContainer = "_jv-2";
export var submittedComment = "_jv-c";
export var thankYouText = "_jv-8";